import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./PolicyHistory.scss";
import Cookies from "universal-cookie";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";


class PolicyHistory extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.city_name = this.cookies.get("city_name");
    this.city_id = this.cookies.get("city_id");
    this.student_is_manager = this.cookies.get("student_is_manager");

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.state = {
      metricsJSON: "",
      nowCosts: [],
      nowRevenue: [],
      everythingTable: [],
    };
  }



  render() {
    //   if(this.props.policyJSON){
    //       console.log(this.props.policyJSON)
    //   }
    //   if(this.props.allPolicyData){
    //       console.log("Good to go.")
    //       this.props.allPolicyData.map((item) => {
    //           console.log(item)
    //       })
    //   }
    return (
      <div className={`${this.props.display === "show" ? "active" : "hidden"}`}>
        <ReactCSSTransitionGroup
          transitionName="fade"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          <div className="policyModal">
            <div className="policyModal-content">
              <table id="policyModal">
                <thead>
                  <tr>
                    <th className="headerClass">
                      District{" "}
                    </th>
                    <th className="headerClass">
                      Policy{" "}
                    </th>
                    {this.props.allPolicyData 
                    ? this.props.allPolicyData[0].year.map((item, index) => (
                        <th>{parseInt(item) - 1}</th>
                    ))
                    : null}
                  </tr>
                </thead>
                <tbody>
                  {this.props.allPolicyData
                    ? this.props.allPolicyData.sort().map((item, index) => (
                        <tr key={index} className="policyModalTableRow">
                          <td>
                            {item.district_name}
                          </td>
                          <td>
                          {item.policy_submittions[0].policies[0].policyName.map((name) => (
                            <tr>
                                <td>
                                    {name}
                                </td>
                            </tr>
                                ))
                            }
                            </td>
                          {item.policy_submittions[0].policies.map((name) => (
                              <td>
                              {name.policyChoice.map((item, index) => (
                                    <tr>
                                        <td>
                                            {item}
                                        </td>
                                    </tr>

                              ))}
                              </td>
                                ))
                            }
                        </tr>
                      ))
                    : null}
                </tbody>
              </table>
              <span className="close" onClick={this.props.closeModal}>
                &times;
              </span>
            </div>
          </div>
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default withRouter(PolicyHistory);
